import React, { Fragment, useState } from 'react';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import Input from 'components/formsy/Input';
import TwyneURL from 'components/formsy/TwyneURL';

import APICkecker from '../APICkecker';

export default function Twyne({ name, data = {} }) {
  const [username, setUsername] = useState(data.username || '')
  const [password, setPassword] = useState(data.password || '')
  const [url, setUrl] = useState(data.url || '')
  const [group, setGroup] = useState(data.group || '')

  return <>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Url</Label>
          <TwyneURL required
            name='url'
            value={url}
            onChange={setUrl}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Group(s). <small>use comma to select more them one.</small></Label>
          <Input
            name='group'
            value={group}
            onChange={setGroup}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Username</Label>
          <Input required
            name='username'
            value={username}
            onChange={setUsername}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Password</Label>
          <Input type="password" required
            name='password'
            value={password}
            onChange={setPassword}
          />
        </FormGroup>
      </Col>
    </Row>
    <APICkecker
      partner={name}
      credentials={{ username, password, url, group }}
    />
  </>
}
